var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"root"}},[_c('div',{class:_vm.cssClasses},[_c('router-view',{attrs:{"name":"layout","is-x-small":_vm.screen.isXSmall,"is-large":_vm.screen.isLarge}},[_c('div',{staticClass:"content"},[_c('router-view',{attrs:{"name":"content"}})],1)])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }